<script>
    import AcceptButton from './AcceptButton'
    import AnswerForm from './AnswerForm'
    import BasePopover from './BasePopover'
    import FileOrPicture from './FileOrPicture'
    import FilesList from './FilesList'
    import FollowButton from '../../shared/FollowButton'
    import QuestionEdit from './QuestionEdit'
    import SubmitTriggerButton from '../../shared/SubmitTriggerButton'
    import VoteComponent from './VoteComponent'
    import FollowPopover from './FollowPopover'
    import VotePopover from './VotePopover'
    import StyleguideComponents from '../../shared/index'

    export default {
		name: 'QuestionsComponent',
        components: {
            AcceptButton,
            AnswerForm,
            BasePopover,
            FileOrPicture,
            FilesList,
            FollowButton,
            QuestionEdit,
            SubmitTriggerButton,
            VoteComponent,
            VotePopover,
            FollowPopover,
            ...StyleguideComponents
        },
		data: function () {
			return {
				file: [],
				modalParams: {},
				activeModal: null,
				visibleComments: {},
				editableAnswerId: null
			};
		},
		methods: {
			editAnswer: function (answerId) {
				this.editableAnswerId = answerId;
			},
			reportAnswer (answerId) {
				this.modalParams = {
					reportableId: answerId,
					reportable: 'answer_id',
					title: 'Report answer',
					reasons: ['Spam', 'Violates Community Guidelines']
				};
				this.activeModal = 'report-modal';
			},
			reportQuestion (questionId) {
				this.modalParams = {
					reportableId: questionId,
					reportable: 'question_id',
					title: 'Report question',
					reasons: ['Spam', 'Violates Community Guidelines']
				};
				this.activeModal = 'report-modal';
			},
			reportComment (commentId) {
				this.modalParams = {
					reportableId: commentId,
					reportable: 'comment_id',
					title: 'Report comment',
					reasons: ['Spam', 'Violates Community Guidelines']
				};
				this.activeModal = 'report-modal';
			},
			deleteAnswer (answerId) {
				this.modalParams = {
					deletable: 'answer',
					redirectPath: location.pathname,
					deletePath: '/answers/' + answerId
				};
				this.activeModal = 'delete-modal';
			},
			deleteQuestion (questionId) {
				this.modalParams = {
					deletable: 'question',
					redirectPath: Grabcad && Grabcad.currentGroup ? '/groups/' + Grabcad.currentGroup : '/questions',
					deletePath: '/questions/' + questionId
				};
				this.activeModal = 'delete-modal';
			},
			deactivateModal () {
				this.activeModal = null;
			},
			toggleComments (commentable, event) {
				event.target.classList.toggle('active');
				let value = this.visibleComments[commentable];
				this.$set(this.visibleComments, commentable, !value);
			}
		},
		mounted: function () {
			this.$on('cancelEditableAnswer', () => {
				this.editableAnswerId = null;
			});
			this.$eventHub.$on('reportComment', comment => {
				this.reportComment(comment.id);
			});
		}
	}
</script>